<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/reports"></ion-back-button>
    </ion-buttons>
    <smr-stylist-picker
      [stylistID]="stylistID"
      [readOnly]="readOnlyStylistPicker"
      [showAllStaff]="true"
      (onInit)="onStylistPickerInit($event)"
      (stylistSelect)="onStylistSelect($event)"
      cssClass="smr-stylist-picker-for-clientreport"
    >
    </smr-stylist-picker>
  </ion-toolbar>
  <ion-toolbar *ngIf="tab == 'totals'">
    <salonmonster-date-picker
      [startDate]="startDate"
      [endDate]="endDate"
      [disabled]="isLoading"
      (rangeChanged)="rangeChanged($event)"
    ></salonmonster-date-picker>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingStylistPicker || errorOccurredWhileLoadingStats"
    (click)="onTapToReload()"
  ></salonmonster-tap-retry>

  <ng-container
    *ngIf="!isLoading && !errorOccurredWhileLoadingStylistPicker && !errorOccurredWhileLoadingStats"
  >
    <ion-toolbar class="ion-no-padding">
      <ion-buttons class="tab-group">
        <ion-button
          [ngClass]="{ 'tab-checked': tab == 'totals' }"
          class="tab-button"
          (click)="tab = 'totals'; onTabChange()"
          >Totals</ion-button
        >
        <ion-button
          [ngClass]="{ 'tab-checked': tab == 'retention' }"
          class="tab-button"
          (click)="tab = 'retention'; onTabChange()"
          >Retention</ion-button
        >
      </ion-buttons>
    </ion-toolbar>

    <ng-container *ngIf="tab == 'totals'">
      <ion-slides pager>
        <ion-slide>
          <ion-col size="12" size-md="12">
            <div style="height: 45vh; display: flex; justify-content: center">
              <canvas
                baseChart
                [data]="clientTotalsChartData"
                [type]="ChartType"
              >
              </canvas>
            </div>
          </ion-col>
        </ion-slide>
        <ion-slide>
          <ion-col size="12" size-md="12">
            <div style="height: 45vh; display: flex; justify-content: center">
              <canvas baseChart [data]="lineChartData" [type]="lineChartType">
              </canvas>
            </div>
          </ion-col>
        </ion-slide>
      </ion-slides>
      <p-table
        styleClass="sticky-table"
        [columns]="cols"
        [value]="stats"
        sortMode="multiple"
        [responsive]="true"
      >
        <ng-template pTemplate="caption">
          <div class="ui-helper-clearfix" style="text-align: right">
            <span class="export">Export to:</span>
            <ion-button
              fill="outline"
              (click)="exportExcel()"
              style="margin-right: 0.5em"
              >Excel</ion-button
            >
            <ion-button fill="outline" (click)="exportPdf()"> PDF </ion-button>
          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
              <div [ngClass]="{'text-align-center': col.field !=='timestamp'}">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-stat let-columns="columns">
          <tr>
            <td
              [ngClass]="{'center-numbers-table-wider-padding': col.field !=='timestamp'}"
              *ngFor="let col of columns"
            >
              <!--span class="ui-column-title">{{ col.header }}</!--span-->
              {{stat[col.field]}}
              <span *ngIf="col.field === 'newClientsPercentage'">%</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td><strong>Total</strong></td>
            <td class="center-numbers-table-wider-padding">
              {{ summaryNumClients() }}
            </td>
            <td class="center-numbers-table-wider-padding">
              {{ summaryNumNewClients() }}
            </td>
            <td class="center-numbers-table-wider-padding">
              {{ summaryPercentNewClients() }} %
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>

    <ng-container *ngIf="tab == 'retention'">
      <ion-row>
        <ion-col class="hidden-sm-down"></ion-col>

        <ion-col size="12" size-sm="12">
          <ion-grid>
            <ion-row>
              <ion-col
                size="12"
                size-sm="12"
                size-md="4"
                size-lg="4"
                size-xl="4"
                class="ion-text-center"
              >
                <p>New clients</p>
                <div style="height: 40vh">
                  <canvas
                    baseChart
                    [data]="retentionNewClientsChartData"
                    [type]="ChartType"
                    [options]="retentionChartOptions"
                  >
                  </canvas>
                </div>
              </ion-col>
              <ion-col
                size="12"
                size-sm="12"
                size-md="4"
                size-lg="4"
                size-xl="4"
                class="ion-text-center"
              >
                <p>Existing clients</p>
                <div style="height: 40vh">
                  <canvas
                    baseChart
                    [data]="retentionExistingClientsChartData"
                    [type]="ChartType"
                    [options]="retentionChartOptions"
                  >
                  </canvas>
                </div>
              </ion-col>
              <ion-col
                size="12"
                size-sm="12"
                size-md="4"
                size-lg="4"
                size-xl="4"
                class="ion-text-center"
              >
                <p>Overall clients</p>
                <div style="height: 40vh">
                  <canvas
                    baseChart
                    [data]="retentionOverallChartData"
                    [type]="ChartType"
                    [options]="retentionChartOptions"
                  >
                  </canvas>
                </div>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col>
                <ion-item class="ion-text-center">
                  Percentage of clients who returned within 90 days
                </ion-item>
              </ion-col>
            </ion-row>

            <ion-row class="ion-margin-top">
              <ion-col> </ion-col>
              <ion-col>
                <h4>Total</h4>
              </ion-col>
              <ion-col>
                <h4>Returned #</h4>
              </ion-col>
              <ion-col>
                <h4>Returned %</h4>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col> New clients </ion-col>
              <ion-col> {{ retentionTable.totalNewClients }} </ion-col>
              <ion-col> {{ retentionTable.newClientsReturned }} </ion-col>
              <ion-col> {{ retentionTable.newClientsPercentage }}% </ion-col>
            </ion-row>

            <ion-row>
              <ion-col> Existing clients </ion-col>
              <ion-col> {{ retentionTable.totalExistingClients }} </ion-col>
              <ion-col> {{ retentionTable.existingClientsReturned }} </ion-col>
              <ion-col>
                {{ retentionTable.existingClientsPercentage }}%
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col> Total clients </ion-col>
              <ion-col> {{ retentionTable.overallTotal }} </ion-col>
              <ion-col> {{ retentionTable.overallReturned }} </ion-col>
              <ion-col>
                {{ retentionTable.overallReturnedPercentage }}%
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>

        <ion-col class="hidden-sm-down"></ion-col>
      </ion-row>
    </ng-container>
  </ng-container>
</ion-content>
